import $ from "jquery";
import Ajax from "./ajax/Ajax";
import { domain } from "./managment/ajax/Ajax";

export async function ipLookUp() {
  $.ajax("http://ip-api.com/json").then(
    function success(response) {},

    function fail(data, status) {
      console.log("Request failed.  Returned status of", status);
    }
  );
}

export async function getLocation(callback) {
  if ("geolocation" in navigator) {
    // check if geolocation is supported/enabled on current browser
    let position = await navigator.geolocation.getCurrentPosition(
      function success(position) {
        // for when getting location is a success
        console.log(
          "latitude",
          position.coords.latitude,
          "longitude",
          position.coords.longitude
        );

        let location = {
          lat: position.coords.latitude,
          lon: position.coords.longitude,
        };

        callback(location);
      },
      function error(error_message) {
        // for when getting location results in an error
        console.error(
          "An error has occured while retrieving location",
          error_message
        );

        callback(false);
      }
    );

    return position;
  } else {
    // geolocation is not supported
    // get your location some other way
    console.log("geolocation is not enabled on this browser");
    await this.ipLookUp();
  }
}

export let fetchBusinessCategories = async () => {
  let response = await Ajax.fetchData(
    domain + "/en/api/shop/v1/business-categories/"
  );
  if (response) {
    console.log(response);
    if (response.status === 200) {
      return response.categories;
    }
  }
};

export async function makePayment(amount) {
  let uid = "do5e3jqgMgeX31p4rOaIrYsggFH3";
  let products = [
    {
      product_1: {
        name: "Suit Brush",
        quantity: 1,
        unit_price: amount,
        category: "fashion & beauty",
        reference: "DF23A",
        description: "Black color suit brush with grippy handle",
      },
    },
  ];

  let url =
    "https://www.wecashup.com/api/v2.0/mechants/" + uid + "/transactions";

  let payload = {
    mechant_public_key: "pk_live_tyRHRuJZfskoCcQw",
    transaction_type: "payment",
    transaction_method: "pull",
    transaction_provider_mode: "telecom",
    transaction_receiver_currency: "XAF",
    transaction_receiver_total_amount: amount,
    transaction_receiver_reference: "GDA3D",
    transaction_sender_currency: "XAF",
    transaction_sender_total_amount: amount,
    transaction_sender_phone_number: "237650426514",
    transaction_sender_lang: "en",
    transaction_product_data: products,
  };

  console.log("about to pay");

  let response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: JSON.stringify(payload),
  });

  if (response.ok) {
    let response_data = await response.json();
    console.log(response_data);
    return response_data;
  }
}

function parseDistance(distance) {
  return distance > 1000
    ? (distance / 1000).toFixed(2).toLocaleString() + "km"
    : distance.toLocaleString() + "m";
}

export default parseDistance;
